import { render, staticRenderFns } from "./FormGroupHorizontal.vue?vue&type=template&id=3a0836f8&"
import script from "./FormGroupHorizontal.vue?vue&type=script&lang=js&"
export * from "./FormGroupHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./FormGroupHorizontal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports